import { IBedType } from '../../../shared/constants/bed-type';

export enum BedCountTypes {
  Operational,
  Occupied,
}

export interface BedCountChangeEventArgs {
  changedFieldValue: number | null;
  changedFieldCoords: {
    countType: BedCountTypes;
    bedType: IBedType;
  };
  nextFieldCoords?: { row: number; col: number };
}
